
jQuery('body').on('mousedown' , '.salonswitcher', salonModal );
jQuery('body').on('mousedown' , '.mobile-salonswitcher', salonMobileModal );
jQuery('body').on('mousedown' , '.stylistswitcher', stylistModal );
jQuery('body').on('mousedown' , '.mobile-stylistswitcher', stylistMobileModal );

// open clearCartModal for salon switcher button if wp-bigcommerce_cart_item_count cookie is greater than 1
function salonModal() {
    var cookies = document.cookie
    .split(';')
    .map(cookie => cookie.split('='))
    .reduce((accumulator, [key,value])=>
        ({...accumulator,[key.trim()]: decodeURIComponent(value)}),
         {});

    var cartCount = cookies["wp-bigcommerce_cart_item_count"];
    var salonSwitcher = document.getElementsByClassName('salonswitcher')[0];

        if (cartCount >= 1) {
            salonSwitcher.setAttribute('data-open', 'clearCartModal');
        }
         else {
            salonSwitcher.removeAttribute('data-open');
            salonSwitcher.href =  '/products/?simode=orderer';
         }
}
// open clearCartModal for mobile salon switcher button if wp-bigcommerce_cart_item_count cookie is greater than 1
function salonMobileModal() {
    var cookies = document.cookie
    .split(';')
    .map(cookie => cookie.split('='))
    .reduce((accumulator, [key,value])=>
        ({...accumulator,[key.trim()]: decodeURIComponent(value)}),
         {});

    var cartCount = cookies["wp-bigcommerce_cart_item_count"];
    var salonSwitcher = document.getElementsByClassName('mobile-salonswitcher')[0];

        if (cartCount >= 1) {
            salonSwitcher.setAttribute('data-open', 'clearCartModal');
        }
         else {
            salonSwitcher.removeAttribute('data-open');
            salonSwitcher.href =  '/products/?simode=orderer';
         }
}
// open clearCartModal for stylist switcher button if wp-bigcommerce_cart_item_count cookie is greater than 1
function stylistModal() {
    var cookies = document.cookie
        .split(';')
        .map(cookie => cookie.split('='))
        .reduce((accumulator, [key,value])=>
            ({...accumulator,[key.trim()]: decodeURIComponent(value)}),
            {});

        var cartCount = cookies["wp-bigcommerce_cart_item_count"];
        var stylistSwitcher = document.getElementsByClassName('stylistswitcher')[0];

        if (cartCount >= 1) {
            stylistSwitcher.setAttribute('data-open', 'clearCartModal')
        }
        else {
            stylistSwitcher.removeAttribute('data-open');
            stylistSwitcher.href =  '/products/?simode=stylist';
        }
}
// open clearCartModal for stylist switcher button if wp-bigcommerce_cart_item_count cookie is greater than 1
function stylistMobileModal() {
    var cookies = document.cookie
        .split(';')
        .map(cookie => cookie.split('='))
        .reduce((accumulator, [key,value])=>
            ({...accumulator,[key.trim()]: decodeURIComponent(value)}),
            {});

        var cartCount = cookies["wp-bigcommerce_cart_item_count"];
        var stylistSwitcher = document.getElementsByClassName('mobile-stylistswitcher')[0];

        if (cartCount >= 1) {
            stylistSwitcher.setAttribute('data-open', 'clearCartModal')
        }
        else {
            stylistSwitcher.removeAttribute('data-open');
            stylistSwitcher.href =  '/products/?simode=stylist';
        }
}
